import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

import { SETUP_EMAIL_PATH, DASHBOARD_PATH } from '../../constants/paths';

import RegistrationComponent from './registrationComponent';

const RegistrationContainer: React.FC = () => {
  const navigate = useNavigate();

  const handleEnter = () => {
    navigate(SETUP_EMAIL_PATH);
  };

  useEffect(() => {
    if (localStorage.getItem('AUTH_USER_DATA')) {
      navigate(DASHBOARD_PATH, { replace: true });
    }
  }, [navigate]);

  return <RegistrationComponent onEnter={handleEnter} />;
};

export default RegistrationContainer;
